// tslint:disable:only-arrow-functions
import { Http } from '@angular/http';
import { NativeStorage } from '@ionic-native/native-storage';
import { Store } from '@ngrx/store';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AuthConfig, AuthHttp } from 'angular2-jwt';
import { Platform } from 'ionic-angular';
import { StorageService } from '../core/services/storage/storage.service';
import { ConfigQueries } from '../vas/business-objects/config/config.queries';
import * as fromRoot from '../vas/store/bootstrap';
import { VasState } from '../vas/store/store-type';
import { RemoteThumbnailService } from './services/remote-thumbnail.service';
import { ENV } from '../environments/environment';

export function getAuthHttp(store: Store<fromRoot.State>, http: Http): AuthHttp {
    return new AuthHttp(new AuthConfig({
        headerName: 'Authorization',
        headerPrefix: 'Bearer',
        tokenName: 'token',
        tokenGetter: (() => {
            return store.select(ConfigQueries.getAuthToken)
                .take(1)
                .toPromise();
        }),
        noJwtError: true,
        globalHeaders: []
    }), http);
}

export function createTranslateLoader(http: Http): TranslateHttpLoader {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export function getStorageServiceForState(nativeStorage: NativeStorage, platform: Platform): StorageService {
    return new StorageService(nativeStorage, platform, 'vas-state');
}

export function getStorageServiceForChangeLogQ(nativeStorage: NativeStorage, platform: Platform): StorageService {
    return new StorageService(nativeStorage, platform, 'vas-change-q');
}

export function remoteThumbnailServiceFactory(
    http: Http,
    store: Store<VasState>
): RemoteThumbnailService {
    return new RemoteThumbnailService(ENV.thumbnailerUrl, http, store);
}



// WEBPACK FOOTER //
// ./src/app/app.module.helpers.ts